// 指令飞行接口
import req from './index'


// 获取M3机场编号
export const getAirportNumber = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.GetRoutesInfo', params)
}

// 获取M3机场编号
export const getM30AirportNumber = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.M30GetRoutesInfo', params)
}


//获取指令飞行WebSocket地址列表 type: 0  (M3) || 1  (M30) 
export const getWebSocketAddress = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.RemoteMonitoring', params)
}

//获取M3巡检监控的直播状态
export const getLiveAddressState = (params) => {
  return req.get('api/admin.php?s=Admin.M3Drone.GetDockLiveStatus', params)
}

//获取M30直播地址
export const getAirLiveAddress = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.live_address', params)
}


// 起飞前往航点 takeoff
export const goToPointByTakeoff = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.TakeoffToPoint', params)
}

// 起飞前往航点 flyto
export const goToPointByFlyTo = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.FlyToPoint', params)
}

// 返航
export const returnHome = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.ReturnHome', params)
}


// 开始录像
export const startVideoAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.CameraVideoStart', params)
}

// 结束录像
export const endVideoAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.CameraVideoStop', params)
}

// 拍照
export const takePhotoAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.CameraPhotoTake', params)
}

// 切换镜头
export const changeLensAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.LiveLensChange', params)
}

// 修改变焦倍率
export const modifyZoomValueAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.CameraFocalLength', params)
}

// 云台 俯仰角控制
export const panTiltControlAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.PayloadCommands', params)
}

// 获取机场无人机健康信息
export const getAirportHealthInfoAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetDockHms', params)
}

// 机场无人机健康信息 已读
export const airportHealthInfoReadAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UpdateHms', params)
}

// 停止flyto前往
export const stopFlytoAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.FlyStopToPoint', params)
}

// 取消返航
export const cancelReturnFlightAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.ReturnHomeCancle', params)
}

// 暂停、继续执行 航线任务
export const updateJobStatusAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UpdateJobStatus', params)
}




// 获取航线信息
export const getLinePointApi = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetAll_RoutesPointList', params)
}

// 获取KML文件的航线信息
export const getKmlLinePointApi = (params) => {
  return req.post('api/admin.php?s=Admin.DockRoute.PipeOverviewKml_Get', params)
}

// 控制操作器
export const controlOperatorAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.DrcController', params)
}

// 获取喊话器信息
export const controllerAPI = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.speakerController', params)
}






